import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { Channel, ChannelPayload, Connection, ConnectionPayload } from "../interfaces";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class PlatformService {
  constructor(private http: HttpClient, private httpService: HttpService) {}

  getInstagramAuthorizationUri(state: string): string {
    const uri = new URL('https://www.facebook.com/v20.0/dialog/oauth');
    uri.searchParams.append('client_id', '417648427175138');
    uri.searchParams.append('redirect_uri', 'https://subscrib.ly/connection/instagram');
    uri.searchParams.append('scope', [
      'instagram_basic',
      'instagram_manage_comments',
      'read_insights',
      'instagram_content_publish',
      'instagram_manage_insights',
      'pages_manage_posts',
      'pages_manage_engagement',
      'pages_manage_ads',
      'pages_manage_metadata',
      'pages_read_engagement',
      'pages_read_user_content',
    ].join(','));
    uri.searchParams.append('state', state);
    return uri.href;
  }

  getThreadsAuthorizationUri(state: string): string {
    const uri = new URL('https://threads.net/oauth/authorize');
    uri.searchParams.append('client_id', '1020708439720342');
    uri.searchParams.append('redirect_uri', 'https://subscrib.ly/connection/threads');
    uri.searchParams.append('scope', [
      'threads_basic',
      'threads_content_publish',
      'threads_manage_insights',
    ].join(','));
    uri.searchParams.append('state', state);
    return uri.href;
  }

  getTwitchAuthorizationUri(state: string): string {
    const uri = new URL('https://id.twitch.tv/oauth2/authorize');
    uri.searchParams.append('client_id', 'ribg8nnyre2m3x49tz00jjpkbicmp8');
    uri.searchParams.append('redirect_uri', 'https://subscrib.ly/connection/twitch');
    uri.searchParams.append('response_type', 'code');
    uri.searchParams.append('scope', [
      'user:read:moderated_channels',
      'channel:manage:videos',
      'chat:edit',
      'chat:read'
    ].join(' '));
    uri.searchParams.append('state', state);
    return uri.href;
  }

  getFacebookAuthorizationUri(state: string): string {
    const uri = new URL('https://www.facebook.com/v20.0/dialog/oauth');
    uri.searchParams.append('client_id', '417648427175138');
    uri.searchParams.append('redirect_uri', 'https://subscrib.ly/connection/facebook');
    uri.searchParams.append('scope', [
      'read_insights',
      'publish_to_groups',
      'pages_manage_posts',
      'pages_manage_engagement',
      'pages_manage_ads',
      'pages_manage_metadata',
      'pages_read_engagement',
      'pages_read_user_content',
    ].join(','));
    uri.searchParams.append('state', state);
    return uri.href;
  }

  getTikTokAuthorizationUri(state: string): string {
    const uri = new URL('https://www.tiktok.com/v2/auth/authorize');
    uri.searchParams.append('client_key', 'awull21585zagkan');
    uri.searchParams.append('response_type', 'code');
    uri.searchParams.append('redirect_uri', 'https://subscrib.ly/connection/tiktok');
    uri.searchParams.append('scope', ['user.info.basic', 'video.publish', 'video.upload', 'video.list', 'user.info.profile', 'user.info.stats'].join(','));
    uri.searchParams.append('state', state);
    return uri.href;
  }

  getYouTubeAuthorizationUri(state: string): string {
    const uri = new URL('https://accounts.google.com/o/oauth2/auth');
    uri.searchParams.append('client_id','1062672550771-rnq3sprrg4uspi49djqjuc590bik7ugo.apps.googleusercontent.com');
    uri.searchParams.append('response_type', 'code');
    uri.searchParams.append('redirect_uri', 'https://subscrib.ly/connection/youtube');
    uri.searchParams.append('scope', ['https://www.googleapis.com/auth/youtube'].join(' '));
    uri.searchParams.append('state', state);
    return uri.href;
  }

  getGMBAuthorizationUri(state: string): string {
    const uri = new URL('https://accounts.google.com/o/oauth2/auth');
    uri.searchParams.append('client_id','1062672550771-rnq3sprrg4uspi49djqjuc590bik7ugo.apps.googleusercontent.com');
    uri.searchParams.append('response_type', 'code');
    uri.searchParams.append('redirect_uri', 'https://subscrib.ly/connection/youtube');
    uri.searchParams.append('scope', ['https://www.googleapis.com/auth/plus.business.manage'].join(' '));
    uri.searchParams.append('state', state);
    return uri.href;
  }

  getDiscordAuthorizationUri(state: string): string {
    const uri = new URL('https://discord.com/api/oauth2/authorize');
    uri.searchParams.append('permissions', '8');
    uri.searchParams.append('client_id','1068295764670951578');
    uri.searchParams.append('response_type', 'code');
    uri.searchParams.append('redirect_uri', 'https://subscrib.ly/connection/discord');
    uri.searchParams.append('scope', ['identify', 'bot', 'guilds', 'email'].join(' '));
    uri.searchParams.append('state', state);
    return uri.href;
  }

  getSlackAuthorizationUri(state: string): string {
    const uri = new URL('https://slack.com/oauth/v2/authorize');
    uri.searchParams.append('client_id', '3740776405924.4536372872320');
    uri.searchParams.append('response_type', 'code');
    uri.searchParams.append('redirect_uri', 'https://subscrib.ly/connection/slack');
    uri.searchParams.append('user_scope', ['channels:read', 'chat:write'].join(','));
    uri.searchParams.append('state', state);
    return uri.href;
  }

  getLinkedInAuthorizationUri(state: string): string {
    const uri = new URL('https://www.linkedin.com/oauth/v2/authorization');
    uri.searchParams.append('client_id', '78j2e6b7enn3ow');
    uri.searchParams.append('response_type', 'code');
    uri.searchParams.append('redirect_uri', 'https://subscrib.ly/connection/linkedin');
    uri.searchParams.append('scope', [
      'r_basicprofile',
      'w_member_social',
      'r_organization_admin',
      'rw_organization_admin',
      'w_member_social',
      'rw_organization_admin',
      // 'r_compliance',
      //'w_compliance'
    ].join(' '));
    uri.searchParams.append('state', state);
    return uri.href;
  }

  getPinterestAuthorizationUri(state: string): string {
    const uri = new URL('https://www.pinterest.com/oauth');
    uri.searchParams.append('client_id', '1480709');
    uri.searchParams.append('response_type', 'code');
    uri.searchParams.append('redirect_uri', 'https://subscrib.ly/connection/pinterest');
    uri.searchParams.append('scope', [
      'user_accounts:read',
      'boards:read',
      'pins:read',
      'pins:write',
    ].join(','));
    uri.searchParams.append('state', state);
    return uri.href;
  }
  
  getLineAuthorizationUri(state: string): string {
    const uri = new URL('https://access.line.me/oauth2/v2.1/authorize');
    uri.searchParams.append('client_id', '1657657369');
    uri.searchParams.append('response_type', 'code');
    uri.searchParams.append('redirect_uri', 'https://subscrib.ly/connection/line');
    uri.searchParams.append('scope', ['profile', 'openid', 'email'].join(' '));
    uri.searchParams.append('state', state);
    return uri.href;
  }

  getXAuthorizationUri(state: string): string {
    const uri = new URL('https://x.com/i/oauth2/authorize');
    uri.searchParams.append('redirect_uri', 'https://subscrib.ly/connection/x');
    uri.searchParams.append('response_type', 'code');
    uri.searchParams.append('client_id', 'cGNOOWFLem4xbEZPajdiQnpGMVM6MTpjaQ');
    uri.searchParams.append('code_challenge', 'challenge');
    uri.searchParams.append('code_challenge_method', 'plain');
    uri.searchParams.append('scope', [
      'tweet.read',
      'tweet.write',
      'users.read',
      'offline.access',
    ].join(' '));
    uri.searchParams.append('state', state);
    return uri.href;
  }

  getAuthorizationUri(platform: string, state: string): string {
    switch(platform) {
        case "facebook":
          return this.getFacebookAuthorizationUri(state)
        case "instagram":
          return this.getInstagramAuthorizationUri(state)
        case "tiktok":
          return this.getTikTokAuthorizationUri(state)
        case "discord":
          return this.getDiscordAuthorizationUri(state)
        case "linkedin":
          return this.getLinkedInAuthorizationUri(state)
        case "pinterest":
          return this.getPinterestAuthorizationUri(state)
        case "youtube":
          return this.getYouTubeAuthorizationUri(state)
        case "threads":
            return this.getThreadsAuthorizationUri(state)
        case "slack":
          return this.getSlackAuthorizationUri(state)
        case "line":
           return this.getLineAuthorizationUri(state)
        case "twitch":
          return this.getTwitchAuthorizationUri(state)
        case "gmb":
          return this.getGMBAuthorizationUri(state)
        case "x":
          return this.getXAuthorizationUri(state)
      }
    return ""
  }

  createConnection(platform: string, accountId: string, code: string): Observable<Connection> {
    return this.http.post<Connection>(
      `${environment.apiBaseUrl}/${platform}/connection`,
      {accountId, code},
    );
  }

  refreshConnection(channelId: string, code: string) {
    return this.http.post<Channel>(
      `${environment.apiBaseUrl}/refresh/channel/${channelId}`,
      {code},
    );
  }

  getChannels(platform: string, connectionId: string) {
    return this.http.get<ChannelPayload[]>(
      `${environment.apiBaseUrl}/${platform}/channels?connectionId=${connectionId}`,
    );
  }

  createChannel(platform: string, connectionId: string, channelPayload: ChannelPayload) {
    return this.http.post<Channel>(
      `${environment.apiBaseUrl}/${platform}/channel/${connectionId}`,
      channelPayload,
    );
  }

}
